import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id CABA2832-65F9-4196-9681-51C5E2C1CFB2
 * name camera-switch-outline
 * version: 2.1.99
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/camera-switch-outline.svg
 * tags
 * - Photography 
 */
export const CameraSwitchOutlineIcon = createSvgIcon(<><path d="M20 4H16.8L15 2H9L7.2 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4M9.9 4H14.1L15.9 6H20V18H4V6H8.1M15 11H9V8.5L5.5 12L9 15.5V13H15V15.5L18.5 12L15 8.5V11Z" /></>, 'CameraSwitchOutlineIcon');
export default CameraSwitchOutlineIcon